import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wallet, CalendarRange, BookOpenCheck, SprayCan, Tag } from 'lucide-react';

const ShortTermRentalsHub = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1 style={{ color: '#1e293b', marginBottom: '20px' }}>Short Term Rentals</h1>
      <p style={{ color: '#64748b', marginBottom: '40px' }}>Select a tool to manage your short term rental business.</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>

        <div
          onClick={() => navigate('/short-term-rentals/financials')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#ecfdf5'}}>
            <Wallet size={32} color="#059669" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Financials</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Track private and company expenses, with automatic VAT calculation.
          </p>
        </div>

        <div
          onClick={() => navigate('/short-term-rentals/planning')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#eff6ff'}}>
            <CalendarRange size={32} color="#2563eb" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Planning</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            View all reservations on a calendar.
          </p>
        </div>

        <div
          onClick={() => navigate('/short-term-rentals/pricing')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#f5f3ff'}}>
            <Tag size={32} color="#7c3aed" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Pricing</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Set nightly prices for future dates.
          </p>
        </div>

        <div
          onClick={() => navigate('/short-term-rentals/bookings')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#fef3c7'}}>
            <BookOpenCheck size={32} color="#d97706" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Bookings</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            View bookings received from Hišica pri orehu.
          </p>
        </div>

        <div
          onClick={() => navigate('/short-term-rentals/cleaning')}
          style={cardStyle}
          className="hover-card"
        >
          <div style={{...iconBoxStyle, backgroundColor: '#fdf2f8'}}>
            <SprayCan size={32} color="#db2777" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Cleaning &amp; Maintenance</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Schedule cleaning, deep cleaning, lawn mowing and other recurring checklists.
          </p>
        </div>

      </div>
    </div>
  );
};

const cardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', cursor: 'pointer', transition: 'all 0.2s ease', border: '1px solid #e2e8f0', height: '100%', boxSizing: 'border-box' };
const iconBoxStyle = { width: '56px', height: '56px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' };

export default ShortTermRentalsHub;
